import { useEffect } from "react";
import { useSiteData } from "../lib/siteApi";

export const FONT_CHOICES = {
  "Libre Franklin": "Libre+Franklin:wght@400;500;600;700",
  Outfit: "Outfit:wght@400;500;600;700",
  "DM Sans": "DM+Sans:wght@400;500;600;700",
  "Plus Jakarta Sans": "Plus+Jakarta+Sans:wght@400;500;600;700",
  "Source Serif 4": "Source+Serif+4:wght@400;600;700",
};

export const defaultDesign = {
  font: "Libre Franklin",
  fontSize: 16,
  lineHeight: 1.7,
  paragraphSpace: 1.1,
  letterSpacing: 0,
  wordSpacing: 0,
};

export default function SiteTheme() {
  const site = useSiteData();
  const design = { ...defaultDesign, ...(site.settings?.design || {}) };

  useEffect(() => {
    const family = FONT_CHOICES[design.font] || FONT_CHOICES["Libre Franklin"];
    const id = "renerg-font";
    let link = document.getElementById(id);
    if (!link) {
      link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
    link.href = `https://fonts.googleapis.com/css2?family=${family}&display=swap`;
    const root = document.documentElement;
    root.style.setProperty("--renerg-font", `"${design.font}", "Segoe UI", sans-serif`);
    root.style.setProperty("--renerg-size", `${Number(design.fontSize) || 16}px`);
    root.style.setProperty("--renerg-leading", String(design.lineHeight || 1.7));
    root.style.setProperty("--renerg-space", `${Number(design.paragraphSpace) || 1.1}em`);
    root.style.setProperty("--renerg-tracking", `${Number(design.letterSpacing) || 0}em`);
    root.style.setProperty("--renerg-word", `${Number(design.wordSpacing) || 0}em`);
  }, [design.font, design.fontSize, design.lineHeight, design.paragraphSpace, design.letterSpacing, design.wordSpacing]);

  return null;
}
